import { Box, alpha, colors } from '@mui/material'
import { memo } from 'react'

import { VISUALISATION } from 'utils'
import { MapLegendColorRamp } from '../MapLegendColorRamp'

export type MapLegendColorRampsProps = {
  jenks: string[]
  ramps: string[]
  visualisationType: (typeof VISUALISATION)[keyof typeof VISUALISATION]
}

export const MapLegendColorRamps = memo<MapLegendColorRampsProps>(
  ({ jenks = [], ramps = [], visualisationType }) => {
    return (
      <Box
        component='div'
        sx={[
          (theme) => ({
            mt: 2,
            mb: 3,
            width: `100%`,
            height: '1.25rem',
            position: 'relative',
            backgroundColor: alpha(colors.grey[800], 0.2),
            display: 'flex',
            [theme.breakpoints.down('mobile')]: {
              mt: 1
            }
          })
        ]}
      >
        {jenks.map((jenk, index) => (
          <MapLegendColorRamp
            key={`${jenk}-${index}`} // so react force re-render the element when, 2 jenk has same value
            length={jenks.length}
            index={index}
            color={ramps[index]}
            value={jenk}
            visualisationType={visualisationType}
            tooltipValue={getTooltipValue({ jenks, index, visualisationType })}
          />
        ))}
      </Box>
    )
  }
)

const getTooltipValue = (
  params: Pick<MapLegendColorRampsProps, 'jenks' | 'visualisationType'> & {
    index: number
  }
) => {
  const { index, jenks, visualisationType } = params

  if (visualisationType === VISUALISATION.CATEGORY) return jenks[index]
  if (visualisationType === VISUALISATION.QUANTITY) {
    const isLast = index === jenks.length - 1
    if (isLast) return `${jenks[jenks.length - 2]} - ${jenks[jenks.length - 1]}`
    return `${jenks[index]} - ${jenks[index + 1]}`
  }
  return 'N/A'
}
